var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-information-box" }, [
    _vm.$mq === "lg"
      ? _c("div", { staticClass: "category-filter__information-box" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "row align-items-start justify-content-between" },
              [
                _c(
                  "div",
                  { staticClass: "catalog-filter__slider slider-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "swiper-wrapper" },
                      _vm._l(
                        _vm.category.widgetCarouselItems,
                        function (model, key, index) {
                          return _c(
                            "div",
                            {
                              class: {
                                "col-m-6 col-l-2": key === 0 || key === 4,
                                "col-l-2": key !== 0 && index !== key,
                              },
                            },
                            [
                              _c("div", { staticClass: "swiper-slide" }, [
                                _c(
                                  "div",
                                  { staticClass: "catalog-filter__item" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "catalog-filter__img" },
                                      [
                                        _c("img", {
                                          attrs: { src: model.image },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "catalog-filter__text" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "catalog-filter__title",
                                          },
                                          [_vm._v(_vm._s(model.title))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "catalog-filter__subtitle",
                                          },
                                          [_vm._v(_vm._s(model.content))]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "slider-arrow slider-arrow__prev" },
                      [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#ic-arr-left" },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "slider-arrow slider-arrow__next" },
                      [
                        _c("svg", { staticClass: "icon" }, [
                          _c("use", {
                            attrs: { "xlink:href": "#ic-arr-right" },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$mq === "sm" || _vm.$mq === "md"
      ? _c("div", { staticClass: "category-filter__slider-box" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-12" },
                [
                  _c(
                    "swiper",
                    {
                      ref: "category-swiper",
                      staticClass: "category-filter__slider",
                      attrs: { options: _vm.swiperOption },
                    },
                    [
                      _vm._l(
                        _vm.category.widgetCarouselItems,
                        function (model, key) {
                          return _c("swiper-slide", { key: key }, [
                            _c("div", { staticClass: "information-box" }, [
                              _c(
                                "div",
                                { staticClass: "information-box__icon" },
                                [
                                  _c("img", {
                                    staticClass: "icon",
                                    attrs: { alt: "icon", src: model.image },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "information-box__title" },
                                [_vm._v(_vm._s(model.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "information-box__sub-text" },
                                [_vm._v(_vm._s(model.content))]
                              ),
                            ]),
                          ])
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "swiper-button-prev category-filter__btn-prev",
                          attrs: { slot: "button-prev" },
                          slot: "button-prev",
                        },
                        [
                          _c("svg", { staticClass: "icon icon-right-arrow" }, [
                            _c("use", {
                              attrs: {
                                "xlink:href":
                                  "static/img/svg/symbol/sprite.svg#right-arrow",
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "swiper-button-next category-filter__btn-next",
                          attrs: { slot: "button-next" },
                          slot: "button-next",
                        },
                        [
                          _c("svg", { staticClass: "icon icon-right-arrow" }, [
                            _c("use", {
                              attrs: {
                                "xlink:href":
                                  "static/img/svg/symbol/sprite.svg#right-arrow",
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }